export default {
    'please-select-account-filter': 'رجاءاٌ اختر حساب من فضلك',
    'please-select-item-filter': 'رجاءاٌ اختر مادة من فضلك',
    'customer-report': 'تقرير العملاء',
    'material-report': 'تقرير المواد'
}